import React, { useState, useRef } from "react";
import ReactPlayer from "react-player";
import { mediaUrl } from "../config/config";
import { theme, websiteColors } from "./../themes/Theme";

const HighlightCard = ({ data }) => {
    const [playing, setPlaying] = useState(false);

    const videoRef = useRef(false);
    return (
        <div>
            {
                data.map((card) => (
                    <div className="app-app-section py-5 px-sm-4 px-4">
                        <div className="row align-items-center text-md-center gap-4 gap-lg-0 gap-xl-5 text-lg-start m-auto ">
                            <div className="col-lg-6 m-auto left-side p-0">
                                <h3 className="app-heading">{card.title}</h3>
                                {card.subTitle && <p className="mt-5 mb-2 mt-lg-0 app-description attendee-subtitle">
                                    {card.subTitle}
                                </p>}
                                <p className="mt-3 mt-lg-0 app-description">
                                    {card.description}
                                </p>
                                <div
                                    className="mt-lg-4 mt-5 m-auto button-group d-sm-block d-none"
                                >
                                {card?.buttons?.accessBtn &&
                                    <a
                                        target="_blank"
                                        href={card?.buttons?.accessBtn?.link}
                                        rel="noopener noreferrer"
                                        className="btn-access me-sm-3 app-button"
                                    >
                                        {card?.buttons?.accessBtn?.name}
                                    </a>
                                 }
                                 {card?.buttons?.demoBtn &&
                                    <a
                                        target="_blank"
                                        href={card?.buttons?.demoBtn?.link}
                                        rel="noopener noreferrer"
                                        className="app-button demo-button"
                                    >
                                        {card?.buttons?.demoBtn?.name}
                                    </a>
                                 }
                                </div>
                            </div>

                            <div className="col-lg-6 mt-3 custom-padding mt-lg-0 text-center">
                                <img
                                    src={card.image}
                                    alt="Check-in App Screenshots"
                                    className="img-fluid rounded app-image"
                                />
                                {/* <ReactPlayer
                        ref={videoRef}
                        url={`${mediaUrl}/kh-check-in-app-demo.mp4`}
                        controls
                        width="100%"
                        height="100%"
                        style={{
                            borderRadius: "5px",
                            padding: "15px",
                            display: "flex"
                        }}
                        pip
                        light={
                            <img
                                src={card.image}
                                className="w-100 h-100"
                                alt="Konfhub Event management platform features"
                            />
                        }
                        playing={playing}
                        playIcon={<></>}
                        onEnded={() => {
                            videoRef.current.showPreview();
                            setPlaying(false);
                        }}
                        onClickPreview={() => {
                            setPlaying(true);
                        }}
                        onStart={() => {
                            setPlaying(true);
                        }}
                        onPause={() => {
                            setPlaying(false);
                        }}
                        onPlay={e => {
                            setPlaying(true);
                        }}
                    /> */}
                            </div>
                        <div
                                className="mt-lg-4 m-auto button-group d-sm-none d-flex ps-0 pe-0"
                            >
                             {card?.buttons?.accessBtn &&
                                <a
                                    target="_blank"
                                    href={card?.buttons?.accessBtn?.link}
                                    className="btn-access me-sm-3 app-button"
                                >
                                    {card?.buttons?.accessBtn?.name}
                                </a>
                             }
                             {card?.buttons?.demoBtn &&
                                <a
                                    target="_blank"
                                    href={card?.buttons?.demoBtn?.link}
                                    className="app-button demo-button"
                                >
                                    {card?.buttons?.demoBtn?.name}
                                </a>
                             }
                            </div>
                        </div>
                    </div>
                ))
            }


            <style jsx>{`

                .app-image{
                    width: 628px;
                }
				.app-heading {
					font-size: 36px;
					font-weight: 600;
					line-height: 44px;
					color: ${websiteColors[theme].headingColor};
					letter-spacing: 2px;
				}
				.app-description {
					font-size: 20px;
					color: #475467;
					font-weight: 400;
					line-height: 30px;
				}
				.app-button {
					font-size: 16px;
					padding: 12px 40px;
					font-weight: 700;
					line-height: 28px;
					border-radius: 4px;
					text-decoration: none;
					text-align: center;
				}
                .attendee-subtitle{
                    margin-top:21px !important;
                    font-weight: 500;
                }
				.btn-access {
					background-color: ${websiteColors[theme].primaryWebsiteTheme};
					color: #fff;
					box-shadow: 0px 1px 2px 0px #1018280d;
				}
				.left-side {
					max-width: 520px;
				}
				.demo-button {
					text-decoration: none;
					border: 1px solid ${websiteColors[theme].primaryWebsiteTheme};
					color: ${websiteColors[theme].primaryWebsiteTheme};
				}

				.app-app-image {
					max-width: 100%;
					height: auto;
					border-radius: 8px;
					padding: 0px !important;
				}
                .button-group{
                    max-width: 564px;          
                }
				@media screen and ((min-width: 768px) and (max-width: 992px)) {
					.left-side {
						max-width: 890px !important;
						width: 100%;
						margin: auto;
					}
				}
				@media screen and (max-width: 576px) {
					.button-group {
						display: flex;
						flex-direction: column;
						gap: 15px;
					}

					.custom-padding {
						padding: 0px !important;
					}
				}
				@media screen and (max-width: 342px) {
					.app-button {
						padding: 10px 10px;
					}
				}
			`}</style>
        </div>
    )
}

export default HighlightCard;